import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import IconButton from '@gp/components/IconButton';
import InfoBubble from '@gp/components/InfoBubble';
import classnames from 'classnames';
import React, {
  Ref,
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';
import { Justify } from 'tea-component';
// import { FILE_TYPES2, SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX, FILE_TYPES_MAP, CONSTANT_TEXTS } from '@gp/constants/const';
import { context } from '@gp/components/Context';
import { FILE_TYPES2, FILE_TYPES_MAP } from '@gp/constants/const';
import useDownload, { createDownloadService } from '@gp/hooks/useDownload';
import { CATEGORIES } from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/Filter/consts';
import '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/Filter/index.scss';
import { projectUpdateListDownload } from '@gp/services/projectUpdate';
import { ContentType } from '../../index.d';

interface ForwardProps {
  setFormModel: (newFormModel: any) => void;
}

const Filter: React.FC<any> = forwardRef((props, ref: Ref<ForwardProps | HTMLElement>) => {
  const {
    className,
    style,
    isAddBtnDisabled: isAddBtnDisabledProps,
    isDownloadBtnDisabled,
    defaultCategory,
    defaultMilestone,
    onAdd,
    onChange,
    setFormModelMilestone,
  } = props;

  const { userIsAbleEdit, projectDetailData, milestones, selectMilestoneId }: ContentType =
    useContext(context) || {};

  // const [options, setOptions] = useState<any>([]);

  // const currentProjectMilestone = milestones?.find(
  //   (item: any) => item?.value === projectDetailData?.current_milestone,
  // );

  // 设置options，加current标识
  // useEffect(() => {
  //   let res = [];
  //   if (Array.isArray(milestones) && currentProjectMilestone?.milestone) {
  //     milestones?.forEach((t: any) => {
  //       res.push({
  //         value: t?.value,
  //         text:
  //           t?.milestone == currentProjectMilestone?.milestone ? (
  //             <span
  //               className="dbg-project-update-milestone-select-item"
  //               title={t.text || '-' + ' (current)'}
  //             >
  //               <span className="item-project-name">{t.text || '-'}</span>
  //               <span className="item-project-milestone-current-sign">
  //                 (current)
  //               </span>
  //             </span>
  //           ) : (
  //             t?.text
  //           ),
  //       });
  //     });
  //   } else {
  //     res = milestones;
  //   }
  //   setOptions(res);
  // }, [milestones, currentProjectMilestone]);

  const [formModel, setFormModel] = useState({
    // milestone: defaultMilestone || [(currentProjectMilestone?.value ?? '')],
    // lastSelectMilestone: defaultMilestone || [(currentProjectMilestone?.value ?? '')],
    milestone: defaultMilestone || [],
    lastSelectMilestone: defaultMilestone || [],
    category: defaultCategory || CATEGORIES?.[0]?.value,
  });

  const outerToSetFormModel = useCallback(
    (newFormModel: any) => {
      setFormModel({ ...{ ...formModel, ...newFormModel } });
    },
    [formModel],
  );

  // 暴露给父组件的方法或属性
  useImperativeHandle(
    ref,
    () => ({
      setFormModel: outerToSetFormModel,
    }),
    [formModel],
  );

  const hasOperationPermission = useMemo(() => !!userIsAbleEdit, [userIsAbleEdit]);

  const isAddBtnDisabled = useMemo(() => {
    return !hasOperationPermission || isAddBtnDisabledProps;
  }, [hasOperationPermission, isAddBtnDisabledProps]);

  // const milestoneLabel = useMemo(() => {
  //   const target = milestones?.find(
  //     (item: any) => item?.value === formModel?.milestone,
  //   );
  //   return target?.text || target?.value || '';
  // }, [formModel?.milestone, milestones]);

  const categoryLabel = useMemo(() => {
    const target = CATEGORIES?.find((item) => item?.value === formModel?.category);
    return target ? target.text : '';
  }, [formModel?.category]);

  const confirm = useCallback(
    (value: any, filterName: string) => {
      if (onChange instanceof Function) {
        onChange(value, filterName);
      }
    },
    [onChange],
  );

  const handleAddClick = useCallback(() => {
    if (isAddBtnDisabled) return;
    if (onAdd instanceof Function) {
      onAdd();
    }
  }, [isAddBtnDisabled, onAdd]);

  // const handleMilestoneChange = useCallback(
  //   (value: string[]) => {
  //     // 重复全选的效果不请求接口
  //     if (
  //       value?.length === options?.length &&
  //       !formModel?.lastSelectMilestone?.length
  //     )
  //       return;
  //     // 当length是全选时，也设置成[]
  //     const realV = value?.length === options?.length ? [] : value;
  //     const newFormModel = {
  //       ...formModel,
  //       milestone: realV,
  //       lastSelectMilestone: realV,
  //     };
  //     setFormModel(newFormModel);
  //     confirm(newFormModel, 'milestone');
  //   },
  //   [formModel, options],
  // );

  const handleCategoryChange = useCallback(
    (value: string) => {
      const newFormModel = { ...formModel, category: value };
      setFormModel(newFormModel);
      confirm(newFormModel, 'category');
    },
    [formModel],
  );

  useEffect(() => {
    setFormModelMilestone(formModel?.milestone);
  }, [formModel?.milestone]);

  const { isDownloading, handleDownload } = useDownload({
    csvDownloadLogKey: 'DETAIL_PROJECT_UPDATE_INFO_CSV_DOWNLOAD_SUBMIT',
    excelDownloadLogKey: 'DETAIL_PROJECT_UPDATE_INFO_EXCEL_DOWNLOAD_SUBMIT',
    downloadService: createDownloadService(projectUpdateListDownload),
  });

  return (
    <>
      <div className={classnames('dbg-project-update-filter', className)} style={{ ...style }}>
        <Justify
          className="dbg-project-update-filter-justify"
          left={
            <>
              <div>
                <ul className="filter-list">
                  {/* <li className="filter-item">
                      <Select
                      matchButtonWidth
                      className="dbg-common-select gp-project-update-milestone-select"
                      appearance="button"
                      boxClassName="dbg-common-select-overlay globalpedia-custom-scrollbar"
                      placeholder=""
                      // defaultValue={formModel?.milestone}
                      value={formModel?.milestone}
                      onChange={handleMilestoneChange}
                      options={options}
                      button={
                        <>
                          <span>Phase: {milestoneLabel}</span>
                        </>
                      }
                    />
                      <GPSelectMultiple
                        className="dbg-common-select gp-project-update-milestone-select"
                        matchButtonWidth
                        boxClassName="dbg-common-select-overlay globalpedia-custom-scrollbar"
                        label="Phase"
                        placeholder="Please select Phase"
                        listHeight={SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX}
                        staging={false}
                        searchable={false}
                        clearable
                        disabled={false}
                        allOption={{
                          text: 'All',
                          value: 'all',
                        }}
                        // groups={{separated: CONSTANT_TEXTS.SELECT_SEPARATED_GROUP_NAME}}
                        options={options}
                        value={formModel?.milestone}
                        onChange={handleMilestoneChange}
                      />
                    </li> */}
                  {/* <li className="filter-item">
                      <Select
                        matchButtonWidth
                        className="dbg-common-select"
                        appearance="button"
                        boxClassName="dbg-common-select-overlay globalpedia-custom-scrollbar"
                        placeholder=""
                        listHeight={SELECT_PANEL_HEIGHT_WITHOUT_SEARCH_BOX}
                        defaultValue={formModel?.category}
                        onChange={handleCategoryChange}
                        options={CATEGORIES}
                        button={
                          <span>
                            <span className="select-button-text">Category</span>
                            <span className="select-button-value">
                              {categoryLabel}
                            </span>
                          </span>
                        }
                      />
                    </li> */}
                </ul>
              </div>
              <InfoBubble
                className="globalpedia-modal-font14"
                style={{ display: 'block', width: 'fit-content' }}
                hasPointer={false}
                customBubbleContent={
                  hasOperationPermission
                    ? ''
                    : 'No permission, if necessary, please contact P-team.'
                }
                DomOrText={
                  <IconButton
                    type="primary"
                    prefix="cross"
                    disabled={isAddBtnDisabled}
                    onClick={handleAddClick}
                  >
                    Add Updates
                  </IconButton>
                }
              />
            </>
          }
          right={
            <>
              <GeneralDownloadBtn
                isLoading={isDownloading}
                isDisabled={isDownloadBtnDisabled || isDownloading}
                fileTypes={FILE_TYPES2}
                onConfirm={(payload) => {
                  const fileType = payload?.fileType || FILE_TYPES_MAP.CSV;
                  handleDownload({
                    fileType,
                    file_type: Number.parseInt(fileType, 10),
                    project_id: projectDetailData?.project_id,
                    // milestone_id: selectMilestoneId,
                    // current_milestone_id: projectDetailData?.current_milestone_id,
                  });
                }}
              />
            </>
          }
        />
      </div>
    </>
  );
});

export default React.memo(Filter);
